const PRINTER_URL = import.meta.env.VITE_PRINTER_URL || "http://127.0.0.1:8080/imprimir"

export interface PrinterPayload {
  nombre: string
  puesto: string
  empresa: string
  folio: string
}

export interface PrinterResult {
  ok: boolean
  message: string
}

export async function sendToPrinter(payload: PrinterPayload): Promise<PrinterResult> {
  console.log("[printer] sendToPrinter llamado →", PRINTER_URL, payload)
  try {
    const res = await fetch(PRINTER_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      signal: AbortSignal.timeout(15000),
    })

    let data: any
    try {
      data = await res.json()
    } catch {
      console.error("[printer] respuesta sin payload JSON válido →", res.status)
      return { ok: false, message: "Error de comunicación con la impresora" }
    }

    console.log("[printer] respuesta →", res.status, data)

    if (!res.ok || data?.status === "error") {
      return { ok: false, message: data?.message ?? "Error desconocido en impresora" }
    }

    return { ok: true, message: data?.message ?? "Impresión exitosa" }
  } catch (err) {
    const msg = err instanceof Error ? err.message : "No se pudo conectar con la impresora"
    console.error("[printer] error →", msg)
    return { ok: false, message: msg }
  }
}
